var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25.4222C0 11.6151 11.1928 0.422241 25 0.422241C38.8071 0.422241 50 11.6151 50 25.4222C50 39.2294 38.8071 50.4222 25 50.4222C11.1928 50.4222 0 39.2294 0 25.4222ZM21.0938 38.7035C21.0938 36.5461 22.8426 34.7972 25 34.7972C27.1574 34.7972 28.9062 36.5461 28.9062 38.7035C28.9062 40.8609 27.1574 42.6097 25 42.6097C22.8426 42.6097 21.0938 40.8609 21.0938 38.7035ZM12.5 25.4222H20.5656L14.9853 9.79724H21.6219L25 19.256L28.3781 9.79724H35.0148L29.4344 25.4222H37.5V31.6722H12.5V25.4222Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "matrix(-1 0 0 -1 50 50.4222)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAccessibility);
export default __webpack_public_path__ + "static/media/home-accessibility.96fb8c9d7b21f26f16d96b8f3d32832c.svg";
export { ForwardRef as ReactComponent };